import { gql } from '@apollo/client';

export const updateCustomerMutation = () => gql`
  mutation Mutation($walletAddress: String!, $customerInfo: CustomerInformationInput) {
    updateCustomer(walletAddress: $walletAddress, customerInfo: $customerInfo)
  }
`;
